import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-base fixed inset-x-0 z-100 flex flex-col gap-3 p-2.5 max-md:bottom-(--tapbar-height) md:hidden',
    header: 'flex items-center justify-between gap-4 pl-2.5',
    content: 'flex flex-col gap-0.5',
    productCount: 'heading-s',
    total: 'heading-l',
    payButtons: 'w-full'
  }
});
